import { useTranslation } from 'react-i18next'

import { Col, Container, Row } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import Section from 'js/components/Section/Section'

import styles from './ColophonPage.module.css'

type ColophonPageProps = {
    colophon: { key: string; label: string; value: string }[]
}

const ColophonPage = ({ colophon }: ColophonPageProps) => {
    const { t } = useTranslation()
    return (
        <Section grow className={styles.wrapper}>
            <Container size="normal">
                <H1 className={styles.title}>
                    {t('entity-magazine.colophon')}
                </H1>
                <Row as="ul" $gutter={40} $spacing={40}>
                    {colophon.map(({ key, label, value }) => (
                        <Col as="li" key={key} mobileLandscapeUp={1 / 2}>
                            <div className={styles.label}>{label}</div>
                            <div className={styles.value}>{value}</div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Section>
    )
}

export default ColophonPage
